// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.
export { rulePlugin } from '@atlaskit/editor-plugin-rule';